export const prices = {
  main: [
    {
      name: {
        ru: 'Монтаж или демонтаж оборудования в арендованную стойку',
        en: 'Mount or remove equipment'
      },
      prices: {
        ru: 400,
        en: 400
      },
      freeQuantity: {
        ru: 1,
        en: 1
      },
      additionalInfo: {
        ru: 'За 1U или за 1 единицу форм-фактора Rack Mount. <br> Работаем по вашему техническому заданию. В ТЗ нужно указать: расположение оборудования в стойке с номерами юнитов, схему подключения кабелей и патч-кордов, описание метода маркировки и список лейблов. <br> В стоимость услуги не входят комплектующие для подключения. <br> Бесплатно: первичный монтаж оборудования по техническому заданию.',
        en: 'Per 1U or 1 non-rack unit. <br> Work is performed according to your work order. The order should include: the equipment’s location in the rack, a diagram of the cable and patch cord configuration, a description of the marking method, and a list of labels. <br> Price does not include mounting hardware. <br> Initial mounting: Free.'
      }
    },
    {
      name: {
        ru: 'Отчетность о физических условиях внутри дата-центра',
        en: 'Report on data center conditions'
      },
      prices: {
        ru: 0,
        en: 0
      },
      freeQuantity: {
        ru: 'не ограничено',
        en: 'unlimited'
      },
      additionalInfo: {
        ru: 'Информирование о физических условиях внутри дата-центра, в котором находится арендованная стойка: температурный режим, энергопотребление и т. п.',
        en: 'Information on the physical conditions inside the data center where the server rack is located (temperature range, energy consumption, etc.).'
      }
    },
    {
      name: {
        ru: 'Технические консультации по услугам',
        en: 'Technical consultation'
      },
      prices: {
        ru: 0,
        en: 0
      },
      freeQuantity: {
        ru: 'не ограничено',
        en: 'unlimited'
      },
      additionalInfo: {
        ru: 'Технические консультации по услугам Компании специалистами инженерно-технического отдела, отдела оплаты и технической поддержки через тикет-систему.',
        en: 'Our engineers, tech support, or payment department will answer any of your questions regarding our services via ticket system.'
      }
    },
    {
      name: {
        ru: 'Консоль в серверном помещении',
        en: 'Mobile console'
      },
      prices: {
        ru: 0,
        en: 0
      },
      freeQuantity: {
        ru: 'не ограничено',
        en: 'unlimited'
      },
      additionalInfo: {
        ru: 'Предоставление передвижной консоли для прямого доступа к оборудованию в серверном помещении. Предоставляем консоль по запросу через тикет-систему или по вашей просьбе при посещении дата-центра.',
        en: 'A mobile console is provided for directly accessing equipment installed in server rooms. Consoles are provided upon request via ticket system or upon direct request during a physical visit to the data center.'
      }
    },
    {
      name: {
        ru: 'Временное хранение оборудования',
        en: 'Temporary equipment storage'
      },
      prices: {
        ru: 2000,
        en: 2000
      },
      freeQuantity: {
        ru: '24 часа в месяц',
        en: '24 hours per month'
      },
      additionalInfo: {
        ru: 'Хранение 1 единицы оборудования и резервных комплектующих на складе.',
        en: 'Store 1 unit of equipment or spare parts in our storage facility.'
      }
    },
    {
      name: {
        ru: 'Аренда ячейки для хранения комплектующих',
        en: 'Locker rental'
      },
      prices: {
        ru: 1500,
        en: 1500
      },
      freeQuantity: {
        ru: '24 часа в месяц',
        en: '24 hours per month'
      },
      additionalInfo: {
        ru: 'Постоянное хранение оборудования и резервных комплектующих в ячейке размером 20×16×6 см. По договорённости может быть предоставлена ячейка большего размера.',
        en: 'Long-term storage for equipment and spare parts in a locker (20×16×16 cm). Larger lockers may be provided depending on availability.'
      }
    },
    {
      name: {
        ru: 'Удаленный доступ к серверу через IP-KVM',
        en: 'KVM over IP (remote access)'
      },
      prices: {
        ru: '100 ₽ / 4 часа',
        en: '₽100 / 4 hours'
      },
      freeQuantity: {
        ru: '10 часов в месяц',
        en: '10 hours per month'
      },
      additionalInfo: {
        ru: 'IP-KVM для удалённого доступа к серверу. В ежемесячную плату включены 10 часов использования IP-KVM. Постоянное подключение IP-KVM осуществляется за отдельную плату.',
        en: 'Remotely access servers via KVM over IP. A permanent KVM over IP connection may be provided for an additional fee.'
      }
    },
    {
      name: {
        ru: 'Чистка оптических портов на оборудовании, коннекторов оптических волокон',
        en: 'Cleaning of optic ports and fiber-optic connectors'
      },
      prices: {
        ru: 400,
        en: 400
      },
      freeQuantity: {
        ru: 2,
        en: 2
      },
      additionalInfo: {
        ru: 'Чистка оптических соединений (портов на кроссах, портов на активном оборудовании, коннекторов на оптических патч-кордах) с применением специального чистящего оборудования. Осуществляется по запросу через тикет-систему.',
        en: 'Clean optic connection points (cross-connect ports, active ports, optic patch cord connectors) with special equipment. Performed upon request via ticket system.'
      }
    },
    {
      name: {
        ru: 'Визуальный осмотр оборудования',
        en: 'Visual inspection of equipment'
      },
      prices: {
        ru: 100,
        en: 100
      },
      freeQuantity: {
        ru: 10,
        en: 10
      },
      additionalInfo: {
        ru: 'По запросу через тикет-систему с отчетом о результатах осмотра.',
        en: 'Performed upon request via ticket system. Results are provided in a report.'
      }
    },
    {
      name: {
        ru: 'Перезагрузка оборудования',
        en: 'Power cycling (reboot)'
      },
      prices: {
        ru: 100,
        en: 100
      },
      freeQuantity: {
        ru: 30,
        en: 30
      },
      additionalInfo: {
        ru: 'Услуга включает мягкую или жесткую перезагрузку оборудования, получение данных POST по запросу, остановку загрузки на этапе BIOS по запросу через тикет-систему.',
        en: 'Service includes a soft or hard reboot, a POST data report (upon request), and/or halting the boot sequence at the BIOS stage (upon request).'
      }
    },
    {
      name: {
        ru: 'Включение и выключение по требованию',
        en: 'On-demand system startup or shutdown'
      },
      prices: {
        ru: 100,
        en: 100
      },
      freeQuantity: {
        ru: 5,
        en: 5
      },
      additionalInfo: {
        ru: 'Отключение производится способом, указанным вами при передаче оборудования. Если вы не сообщили желательного способа отключения, то его можно указать при запросе через тикет-систему или системные инженеры самостоятельно выберут способ.',
        en: 'Systems are shut down as per client instructions (given at time of delivery). If no shutdown method has been specified, our system engineers will proceed with the most appropriate method they see fit.'
      }
    },
    {
      name: {
        ru: 'Маркировка оборудования и сетевых кабелей',
        en: 'Equipment and cable labelling'
      },
      prices: {
        ru: 100,
        en: 100
      },
      freeQuantity: {
        ru: 5,
        en: 5
      },
      additionalInfo: {
        ru: 'Маркировка компонентов инфраструктуры стикером с напечатанной меткой. Осуществляется по запросу через тикет-систему. Содержание метки оговаривается через тикет-систему.',
        en: 'Network equipment is marked with a printed label. Label contents are specified in the request.'
      }
    },
    {
      name: {
        ru: 'Замена кабеля питания',
        en: 'Power cord replacement'
      },
      prices: {
        ru: 200,
        en: 200
      },
      freeQuantity: {
        ru: 1,
        en: 1
      },
      additionalInfo: {
        ru: 'Замена или подключение нового кабеля питания в пределах одной стойки. Вы можете заказать кабели питания за отдельную плату или предоставить свои.',
        en: 'Replace or connect a new power cord for one rack. Cords may be provided by the client or ordered for an additional fee.'
      }
    },
    {
      name: {
        ru: 'Установка и замена трансиверов',
        en: 'Transceiver installation and replacement'
      },
      prices: {
        ru: 100,
        en: 100
      },
      freeQuantity: {
        ru: 2,
        en: 2
      },
      additionalInfo: {
        ru: 'Установка новых или переустановка трансиверов в оборудовании. Трансиверы необходимо предоставить заранее.',
        en: 'Install or replace transceivers. Transceivers must be provided by the client in advance.'
      }
    },
    {
      name: {
        ru: 'Монтаж и демонтаж оптической кроссировки',
        en: 'Mount or remove optical cross connects'
      },
      prices: {
        ru: 400,
        en: 400
      },
      freeQuantity: {
        ru: 2,
        en: 2
      },
      additionalInfo: {
        ru: 'Монтаж или демонтаж оптической кроссировки в пределах одной стойки. Осуществляется по запросу через тикет-систему. В запросе нужно указать маркировку и порты для подключения. Оптические кабели не входят в стоимость услуги.',
        en: 'Mount or remove optical cross connects in one rack. Labels and ports must be specified in the request. Price does not include optical cables.'
      }
    },
    {
      name: {
        ru: 'Монтаж и демонтаж медной кроссировки',
        en: 'Mount or remove copper cross connects'
      },
      prices: {
        ru: 400,
        en: 400
      },
      freeQuantity: {
        ru: 2,
        en: 2
      },
      additionalInfo: {
        ru: 'Монтаж или демонтаж медной кроссировки в пределах одной стойки. Переключение одной медной кроссировки из текущего порта подключения в новый порт. Осуществляется по запросу через тикет-систему. В запросе нужно указать информацию об оборудовании. Услуга предоставляется для оборудования, расположенного в одной стойке, с кабелем достаточной длины.',
        en: 'Mount or remove copper cross connects in one rack. Labels and ports must be specified in the request. Price does not include copper cables.'
      }
    },
    {
      name: {
        ru: 'Перекоммутация оптической, медной кроссировки',
        en: 'Swap optical/copper cross connects'
      },
      prices: {
        ru: 200,
        en: 200
      },
      freeQuantity: {
        ru: 5,
        en: 5
      },
      additionalInfo: {
        ru: 'Переключение одной оптической или медной кроссировки из текущего порта подключения в новый порт в оборудование в арендуемой стойке. Осуществляется по запросу через тикет-систему. В запросе вам нужно указать информацию об оборудовании. Оборудование должно находится в одной стойке, а длина кабеля — быть достаточной для перекоммутации.',
        en: 'Reconnect one optical or copper cross connect to a new port or equipment in the rack. Information about the equipment must be provided in the request. All equipment must be located in the same rack and cables must be long enough to perform the swap.'
      }
    },
    {
      name: {
        ru: 'Замена комплектующих в оборудовании без вскрытия',
        en: 'Parts replacement (no dismantling)'
      },
      prices: {
        ru: 400,
        en: 400
      },
      freeQuantity: {
        ru: null,
        en: null
      },
      additionalInfo: {
        ru: 'Замена компонентов оборудования без непосредственного демонтажа и вскрытия. Осуществляется по запросу через тикет систему. Комплектующие нужно предоставить заранее. Время работ оговаривается в каждом случае индивидуально.',
        en: 'Replace equipment parts without directly removing or dismantling the equipment. Replacement parts must be provided in advance. The time work is to be performed is agreed upon on a case-by-case basis.'
      }
    },
    {
      name: {
        ru: 'Отправка оборудования, передача в ремонт',
        en: 'Delivery for repairs'
      },
      prices: {
        ru: 1600,
        en: 1600
      },
      freeQuantity: {
        ru: null,
        en: null
      },
      additionalInfo: {
        ru: 'Составление заявки, подготовка сопроводительных документов, RMA и отправка в ремонт неисправного оборудования. Для составления сопроводительных документов и RMA вам нужно представить подробное описание неисправности в тикет-системе, указать поставщика оборудования и номер гарантийного талона. Услуги курьера или транспортной компании не входят в стоимость услуги.',
        en: 'Includes the preparation of shipping documents and RMA and shipping faulty equipment for repairs. In order to prepare shipping documents and RMA, you must provide a detailed description of the malfunction, the equipment vendor, and warranty number (if applicable) via ticket system. Price does not include cost of delivery (by courier or shipping company).'
      }
    },
    {
      name: {
        ru: 'Инвентаризация установленного оборудования',
        en: 'Inventory of installed equipment'
      },
      prices: {
        ru: 400,
        en: 400
      },
      freeQuantity: {
        ru: null,
        en: null
      },
      additionalInfo: {
        ru: 'Стоимость услуги указана за 1 стойку. Получение, каталогизация и предоставление информации обо всех физических устройствах и подключениях в стойке по запросу через тикет-систему.',
        en: 'The given cost is for 1 rack. Includes gathering, cataloging, and providing information on all physical devices and connections in a rack.'
      }
    },
    {
      name: {
        ru: 'Подготовка стойки',
        en: 'Rack preparation'
      },
      prices: {
        ru: 6400,
        en: 6400
      },
      freeQuantity: {
        ru: null,
        en: null
      },
      additionalInfo: {
        ru: 'По техническому заданию заказчика, с возможностью последующих модификаций. Для первичного изменения конструктива стойки услуга предоставляется бесплатно. Все дальнейшие изменения внутренней конфигурации проводятся на платной основе по техническому заданию.',
        en: 'Specified in work order and can be subsequently modified. Initial changes to the rack are performed free of charge. All future changes to the internal configuration are performed for pay and as per the submitted work order.'
      }
    },
    {
      name: {
        ru: 'Замена ручек и замков шкафа под индивидуальные ключи',
        en: 'Replacement of cabinet handles and locks'
      },
      prices: {
        ru: 'по запросу',
        en: 'on request'
      },
      freeQuantity: {
        ru: null,
        en: null
      },
      additionalInfo: {
        ru: 'За 1 шт. Замена стандартных замков шкафа на ваши замки происходит по запросу через тикет-систему. После замены один комплект ключей будет отдан вам, а второй будет храниться в индивидуальной ячейке на посту охраны дата-центра и выдаваться по запросу при посещении серверного помещения.',
        en: '1 unit. Replace standard cabinet locks with client-provided locks. Once replaced, one set of keys will be given to the client, a second will be kept in a locker at the security office in the data center. This key may be used during physical visits to the server room.'
      }
    },
    {
      name: {
        ru: 'Предоставление в аренду носителей с предустановленным ПО',
        en: 'Rental of storage device with pre-installed software'
      },
      prices: {
        ru: 200,
        en: 200
      },
      freeQuantity: {
        ru: null,
        en: null
      },
      additionalInfo: {
        ru: 'Предоставление в аренду внешнего носителя (флэш-накопитель, внешний USB-диск, оптический накопитель) с предустановленным свободно распространяемым программным обеспечением (ПО). Ссылку на загрузку дистрибутива необходимого ПО вам нужно будет предоставить через тикет-систему. Время предоставления услуги ограничено 12-ю часами с момента предоставления носителя в аренду.',
        en: 'An external storage device (flash drive, external USB drive, optical drive) may be prepared with free-distribution software and rented. Requests must contain a download link to the necessary software. Storage devices may be used for a maximum of 12 hours, starting the moment the storage device is given to the client.'
      }
    },
    {
      name: {
        ru: 'Замена комплектующих в оборудовании со вскрытием',
        en: 'Parts replacement (dismantling required)'
      },
      prices: {
        ru: 1600,
        en: 1600
      },
      freeQuantity: {
        ru: null,
        en: null
      },
      additionalInfo: {
        ru: 'Замена одного из внутренних компонентов оборудования размещенного в стойке. Осуществляется по запросу через тикет-систему. Необходимые компоненты нужно предоставить заранее. Оплата взимается за каждый установленный компонент.',
        en: 'Replace an internal component of a device in a server rack. Replacement parts must be provided in advance. Payment is due for each installed component.'
      }
    },
    {
      name: {
        ru: 'Установка и переустановка операционной системы',
        en: 'Operating system installation and setup'
      },
      prices: {
        ru: 1600,
        en: 1600
      },
      freeQuantity: {
        ru: null,
        en: null
      },
      additionalInfo: {
        ru: 'Без учета стоимости лицензии. Установка выбранной операционной системы на оборудовании в стойке. Переустанавливаем ОС по запросу через тикет-систему. Время проведения работы оговаривается индивидуально.',
        en: 'Install the operating system of your choice on equipment in a rack. An operating system may be reinstalled upon request. The time work is to be performed is agreed upon on a case-by-case basis. Price does not include OS license.'
      }
    },
    {
      name: {
        ru: 'Тестирование комплектующих',
        en: 'Parts testing'
      },
      prices: {
        ru: 'по запросу',
        en: 'on request'
      },
      freeQuantity: {
        ru: null,
        en: null
      },
      additionalInfo: {
        ru: 'Тестирование комплектующих клиента на нашем стенде. Проводим по запросу через тикет-систему. Оплата взимается за каждый протестированный компонент.',
        en: 'Parts are tested on our stand. Payment is due for each component tested.'
      }
    },
    {
      name: {
        ru: 'Работа с консолью по инструкции',
        en: 'Console work, per client’s instruction'
      },
      prices: {
        ru: null,
        en: null
      },
      freeQuantity: {
        ru: null,
        en: null
      },
      additionalInfo: {
        ru: 'Проведение работ, требующих авторизации на вашем оборудовании, а также переконфигурирование BIOS, EFI, IPMI, ILO, RAID-утилит, HBA-утилит по заранее предоставленному техническому заданию (ТЗ) через тикет-систему. Время проведения работ оговаривается индивидуально. Оплата взимается за каждый час работы с консолью.',
        en: 'Perform work on your equipment that requires authorization, as well as reconfigure BIOS, EFI, IPMI, ILO, RAID, and HBA utilities. The time work is to be performed is agreed upon on a case-by-case basis. Payment is due for each hour of work performed.'
      }
    },
    {
      name: {
        ru: 'Перепрошивка комплектующих',
        en: 'Firmware flash'
      },
      prices: {
        ru: null,
        en: null
      },
      freeQuantity: {
        ru: null,
        en: null
      },
      additionalInfo: {
        ru: 'Специалисты заменят или обновят встроенное программное обеспечение одного из компонентов клиентского оборудования. Ссылку на загрузку дистрибутива программного нужно прислать через тикет систему, время проведения работ оговаривается дополнительно. Оплата взимается за один перепрошитый компонент.',
        en: 'The firmware of a component is either replaced or updated. A download link must be included in the request. The time work is to be performed is agreed upon on a case-by-case basis. Payment is due for each component flashed.'
      }
    },
    {
      name: {
        ru: 'Сборка 1 единицы серверного оборудования и его тестирование',
        en: 'Assembly and testing of equipment (1 unit)'
      },
      prices: {
        ru: 'по запросу',
        en: 'on request'
      },
      freeQuantity: {
        ru: null,
        en: null
      },
      additionalInfo: {
        ru: 'Комплектующие и техническое задание на сборку предоставляет клиент.',
        en: 'Client must provide parts and work order for assembly.'
      }
    },
    {
      name: {
        ru: 'Подготовка пакета документов для сдачи узла связи',
        en: 'Document preparation for registering a communications node'
      },
      prices: {
        ru: 'по запросу',
        en: 'on request'
      },
      freeQuantity: {
        ru: null,
        en: null
      },
      additionalInfo: {
        ru: 'Специалисты инженерно-технического отдела подготовят документы для сдачи узла связи. Узнать срок подготовки документов и уточнить стоимость пакета можно через тикет-систему. Для заказа нужно указать полный перечень необходимых документов. Максимальный срок выполнения — 10 рабочих дней после согласования пакета документов. В услугу не входит сдача документов, только подготовка. Услуга доступна для клиентов, арендующих серверный шкаф.',
        en: 'Our engineering department prepares documents to register a communication node. An estimate of the time needed to prepare the documentation and the cost of the packet may be provided by sending a request via ticket system. To order this service, the full list of necessary documents must be provided. Maximum time required — 10 business days after the document list has been approved. Price does not include document submission, only preparation. Service is only available to clients renting server racks.'
      }
    },
    {
      name: {
        ru: 'Техническая поддержка клиентов Заказчика (аутсорсинг технической поддержки)\n',
        en: 'Technical support for outside clients (tech support outsourcing)'
      },
      prices: {
        ru: 'по запросу',
        en: 'on request'
      },
      freeQuantity: {
        ru: null,
        en: null
      },
      additionalInfo: {
        ru: null,
        en: null
      }
    }
  ],
  additional: [
    {
      name: {
        ru: 'Предоставление и монтаж в каждый шкаф крепежных комплектов М6-16мм «винт-гайка-шайба», 1 комплект',
        en: 'Provision and installation of М6-16 mm mounting kits (bolt-washer-nut), 1 kit'
      },
      prices: {
        ru: 30,
        en: 30
      }
    },
    {
      name: {
        ru: 'Патч-корд UTP, Cat.5, до 1,5 м.',
        en: 'UTP patch cord, Cat. 5, up to 1.5 m.'
      },
      prices: {
        ru: 100,
        en: 100
      }
    },
    {
      name: {
        ru: 'Патч-корд UTP, Cat.5, до 3 м.',
        en: 'UTP patch cord, Cat. 5, up to 3 m.'
      },
      prices: {
        ru: 150,
        en: 150
      }
    },
    {
      name: {
        ru: 'Патч-корд UTP, Cat.5, длиной свыше 3 м., за 1 м.',
        en: 'UTP patch cord, Cat. 5, over 3 m., per 1 m.'
      },
      prices: {
        ru: 150,
        en: 150
      }
    },
    {
      name: {
        ru: 'Шнур оптический дуплексный одномодовый, до 3 м.',
        en: 'Cable, single-mode fiber optic duplex, up to 3 m.'
      },
      prices: {
        ru: 1500,
        en: 1500
      }
    },
    {
      name: {
        ru: 'Шнур питания C13-Schuko до 1,8 м.',
        en: 'Power cord, C13-Schuko, up to 1.8 m.'
      },
      prices: {
        ru: 300,
        en: 300
      }
    },
    {
      name: {
        ru: 'Шнур питания С13-С14 до 1,8 м.',
        en: 'Power cord, С13-С14, up to 1.8 m.'
      },
      prices: {
        ru: 300,
        en: 300
      }
    },
    {
      name: {
        ru: 'Шнур питания С19-С20 до 1,8 м.',
        en: 'Power cord, С19-С20, up to 1.8 m.'
      },
      prices: {
        ru: 500,
        en: 500
      }
    },
    {
      name: {
        ru: 'Адаптер оптический',
        en: 'Fiber-optic adapter'
      },
      prices: {
        ru: 1300,
        en: 1300
      }
    },
    {
      name: {
        ru: 'Иные расходные материалы',
        en: 'Other materials'
      },
      prices: {
        ru: 'по запросу',
        en: 'on request'
      }
    }
  ]
}